import React from 'react';
import {Navigate, Route, Routes, useLocation, useParams} from 'react-router-dom';
import {DocumentTitle} from './DocumentTitle';
import {AuthorizedLayout, RegistrationLayout, UnAuthorizedLayout} from './layouts';
import {RequireAuth} from './router/RequireAuth';
import {RequireGuest} from './router/RequireGuest';
import {DownloadAppPage} from 'pages/download-app';
import {LoginPage} from 'pages/login';
import {NotFoundPage} from 'pages/not-found';
import {OrderPage} from 'pages/order';
import {OrdersPage} from 'pages/orders';
import {OfferPage} from 'pages/offer';
import {OffersPage} from 'pages/offers';
import {NotificationsPage} from 'pages/notifications';
import {ProfilePage, ProfileDataPage, ProfileTermsPage, ProfileDocumentsPage, ProfileStatusesPage, ProfileAutoReplyPage, AddAccountPaymentPage, AddCardPaymentPage, AddSbpPaymentPage, GenerateCertificatePage, GenerateReceiptPage} from 'pages/profile';
import {RegistrationPage} from 'pages/registration';
import {HelpDesk} from './HelpDesk';
import styles from './App.module.css';

/** Мобильный deeplink `/tasks/:id` открывает веб-заказ `/orders/:id`. */
function TaskDeeplinkRedirect(): React.ReactElement {
	const {orderId} = useParams();
	const {search, hash} = useLocation();

	return <Navigate to={`/orders/${orderId ?? ''}${search}${hash}`} replace />;
}

export function App(): React.ReactElement {
	return (
		<div className={styles.root}>
			<DocumentTitle />
			<Routes>
				<Route element={<RequireGuest />}>
					<Route path={'/auth'} element={<UnAuthorizedLayout />}>
						<Route path={'login'} element={<LoginPage />} />
						<Route path={'*'} element={<NotFoundPage />} />
					</Route>
				</Route>
				<Route element={<RequireAuth />}>
					<Route path={'download-app'} element={<DownloadAppPage />} />
					{/* Не path="/" — иначе `/` матчится с пустым Outlet и белый экран. */}
					<Route path={'registration'} element={<RegistrationLayout />}>
						<Route index element={<RegistrationPage />} />
					</Route>
					<Route path={'profile/statuses'} element={<RegistrationLayout />}>
						<Route index element={<ProfileStatusesPage />} />
					</Route>
					<Route path={'/'} element={<AuthorizedLayout />}>
						{/* Главная = предложения; без Navigate, чтобы не ловить лишние редиректы. */}
						<Route index element={<OffersPage />} />
						<Route path={'orders'} element={<OrdersPage />} />
						<Route path={'offers'} element={<OffersPage />} />
						<Route path={'notifications'} element={<NotificationsPage />} />
						<Route path={'profile'} element={<ProfilePage />} />
						<Route path={'profile/data'} element={<ProfileDataPage />} />
						<Route path={'profile/payment-ways/account'} element={<AddAccountPaymentPage />} />
						<Route path={'profile/payment-ways/card'} element={<AddCardPaymentPage />} />
						<Route path={'profile/payment-ways/sbp'} element={<AddSbpPaymentPage />} />
						<Route path={'profile/certificate'} element={<GenerateCertificatePage />} />
						<Route path={'profile/receipt'} element={<GenerateReceiptPage />} />
						<Route path={'profile/terms'} element={<ProfileTermsPage />} />
						<Route path={'profile/documents'} element={<ProfileDocumentsPage />} />
						<Route path={'profile/auto-reply'} element={<ProfileAutoReplyPage />} />
						<Route path={'*'} element={<NotFoundPage />} />
					</Route>
					<Route path={'/'} element={<AuthorizedLayout showHeader />}>
						<Route path={'orders/:orderId'} element={<OrderPage />} />
						<Route path={'tasks/:orderId'} element={<TaskDeeplinkRedirect />} />
					</Route>
					<Route
						path={'/'}
						element={
							<AuthorizedLayout
								showHeader
								headerBackground="#78EAA9"
								hideHeaderOnMobile
								flushMobileContent
							/>
						}
					>
						<Route path={'offers/:offerId'} element={<OfferPage />} />
					</Route>
				</Route>
				<Route path={'*'} element={<NotFoundPage />} />
			</Routes>

			<HelpDesk />
		</div>
	);
}
